<template>
  <div class="flex flex-col h-full" :class="{'max-h-[70vh] pr-3': !full}">
    <section class="flex flex-col md:flex-row gap-2 my-8 flex-shrink-0" :class="[selected.length ? 'md:justify-between' : 'md:justify-end']">
      <h2 class="sr-only">Filters</h2>
      <div v-if="selected.length > 0" class="flex items-center gap-1">
        <span class=" text-bhav-green-600 text-sm">{{ selected.length }} Image(s) selected</span>
        <div v-if="full" @click="handleEdit" class="group hover:bg-bhav-cool-gray-100 rounded pl-0.5 pr-1 gap-0.5 items-center justify-center cursor-pointer">
          <span class="text-bhav-blue-200 group-hover:text-blue-500 font-medium text-sm mr-0.5">Edit</span>
          <span class="text-bhav-blue-200 group-hover:text-blue-500 fak fa-pen text-sm"/>
        </div>
        <div v-if="full" @click="() => { confirm = selected }" class="group hover:bg-bhav-red-100 rounded px-0.5 items-center justify-center"><span class="text-bhav-blue-200 group-hover:text-bhav-red-500 fa fa-trash text-xs"></span></div>
          <div @click="() => { selected = [] }" class="group hover:bg-bhav-cool-gray-100 rounded pl-0.5 pr-1 gap-0.5 items-center justify-center cursor-pointer">
              <span class="text-bhav-blue-200 group-hover:text-blue-500 font-medium text-sm mr-0.5">Clear</span>
              <span class="text-bhav-blue-200 group-hover:text-blue-500 fa fa-times text-sm"/>
          </div>
      </div>
      <div class="flex flex-col md:flex-row items-center gap-2">
        <div class="flex gap-2 items-center">
          <SearchInput v-model="query.search.string" placeholder="Search..." @search="handleSearch" @clear="handleSearchClear" />
        </div>
        <div class="hover:bg-bhav-cool-gray-50 p-1 rounded-lg flex items-center justify-center text-base leading-none cursor-pointer text-bhav-blue-500 relative" @click="() => { isOpen = true; }">
          <span class="fak fa-filter"></span>
          <span v-if="activeFiltersCount > 0" class="absolute bg-bhav-blue-500 text-white text-[.5rem] leading-none p-1 min-w-4 text-center rounded-full bottom-3 left-3">{{ activeFiltersCount }}</span>
        </div>
        <ViewToggle v-model="view" :views="viewOptions" />
        <button v-if="view === 'list'" @click="showColumns = !showColumns" class="px-3 py-2 bg-transparent hover:bg-bhav-cool-gray-50 text-bhav-blue-200 hover:text-bhav-blue-500 rounded-lg text-lg">
          <p class="relative">
            <span class="fak fa-col-options leading-none"></span>
            <span class="sr-only">Open Table Column Preferences Drawer</span>
          </p>
        </button>
        <FormButton v-if="full" @click="() => { confirmCsv = true }" prefix-class="fak" icon="fa-blog" color="gray">Create Report</FormButton>
        <div v-else class="mr-3"></div>
      </div>
    </section>

    <RightDrawer :open="isOpen" title="Filters" :modal-mode="!full" @close="resetFilters">
      <template #default>
        <ul class="mt-2 flex-0 overflow-auto h-full filters-scroll-area">
          <li class="py-3">
            <span class="fak fa-list-view text-bhav-blue-500"></span>
            <MultiselectField label="Category" @update:model-value="(newValue) => { if(!newValue.includes('home')) {filtering.position = []} }" :show-search="false" :show-create="false" :multiple="true" v-model="filtering.category" color="orange" :options="Media.categories" instructions="Select Categories"/>
          </li>
          <li class="py-3">
            <span class="fak fa-shown text-bhav-blue-500"></span>
            <MultiselectField label="Select View"
                              :show-search="false"
                              :show-create="false"
                              :multiple="true"
                              v-model="filtering.position"
                              color="orange"
                              :disabled="!filtering.category.includes('home')"
                              :options="filtering.category.includes('home') ? Media.positions.map(position => ({ label: position, value: position})) : []" instructions="Select Views"
                              container-selector=".filters-scroll-area"
            />
          </li>
          <li class="py-3">
            <span class="fak fa-password text-bhav-blue-500"></span>
            <MultiselectField label="Keywords"
                              :multiple="true"
                              v-model="filtering.keywords"
                              color="orange"
                              :options="keywords.map(keyword => ({ label: keyword.name, value: keyword.id}))" instructions="Select the keywords"
                              container-selector=".filters-scroll-area"
            />
          </li>
          <li class="py-3">
            <span class="fak fa-community text-bhav-blue-500"></span>
            <MultiselectField label="Communities"
                              v-model="filtering.communities"
                              :show-search="true"
                              :show-create="false"
                              search-label="Search for Communities"
                              :multiple="true"
                              color="blue"
                              :options="communities.map(community => ({ label: community.meta?.info?.name ?? community.kova?.WebGroupName, value: community.id }))"
                              instructions="Select Communities"
                              container-selector=".filters-scroll-area"
            />
          </li>
          <li class="py-3">
            <span class="fak fa-collection text-bhav-blue-500"></span>
            <MultiselectField label="Collection"
                              v-model="filtering.collections"
                              :show-search="true"
                              :show-create="false"
                              :multiple="true"
                              search-label="Search for Collections"
                              color="blue"
                              :options="collections.map(item => ({ label: item, value: item }))"
                              instructions="Select Collections"
                              container-selector=".filters-scroll-area"
            />
          </li>
          <li class="py-3">
            <span class="fak fa-floorplan text-bhav-blue-500"></span>
            <MultiselectField label="Floorplans"
                              v-model="filtering.floorplans"
                              :show-search="true"
                              :show-create="false"
                              :multiple="true"
                              search-label="Search for Floorplans"
                              color="blue"
                              :options="availableFloorplan.map(item => ({ label: item, value: item }))"
                              instructions="Select Floorplans"
                              container-selector=".filters-scroll-area"
            />
          </li>
          <!-- <li class="py-3">
              <span class="fak fa-garage text-bhav-blue-500"></span>
              <MultiselectField label="Elevation"
                      v-model="filtering.elevation"
                      :show-search="false"
                      :show-create="false"
                      :multiple="true"
                      color="blue"
                      :options="[]"
                      instructions="Select Elevations"/>
          </li>
          <li class="py-3">
              <span class="fak fa-color-package text-bhav-blue-500"></span>
              <MultiselectField label="Color Package"
                      v-model="filtering.color_package"
                      :show-search="false"
                      :show-create="false"
                      :multiple="true"
                      color="blue"
                      :options="[]"
                      instructions="Select Color Packages"/>
          </li> -->
          <li class="py-3">
            <span class="fak fa-link text-bhav-blue-500"></span>
            <MultiselectField label="Select Attached"
                              v-model="filtering.attached"
                              :show-search="false"
                              :show-create="false"
                              :multiple="false"
                              color="blue"
                              :options="[{ label: 'Attached', value: 'attached'}, { label: 'Unattached', value: 'unattached'}]"
                              instructions="Select Attached"
                              container-selector=".filters-scroll-area"
            />
          </li>
        </ul>
        <nav class="flex items-end justify-between flex-1">
          <div>
            <FormButton color="gray" @click="clearFilters">Clear Filters</FormButton>
          </div>
          <div>
            <FormButton color="blue" @click="applyFilters">Apply Filters</FormButton>
          </div>
        </nav>
      </template>
    </RightDrawer>


    <div class="flex-1 overflow-y-auto px-0.5" :class="[{'sm:max-w-2xl lg:max-w-4xl': !full}]">
      <PaginationGrid v-if="view === 'grid'" :data="filtered" :has-top-nav="true" :server-side="!!pagination" :server-pagination="pagination" @page-change="handlePageChange" @limit-change="handleLimitChange" class="grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <template #card="{items}">
          <Card v-for="item, i in items" :key="`item-${i}`"
                class="col-span-1 flex flex-col"
                :class="{'ring-2 ring-bhav-blue-500': isSelected(item)}">
            <div class="bg-bhav-cool-gray-50 rounded-lg h-full">
              <div class="flex-1 flex flex-col p-0">
                <div class="relative">
                  <div class="absolute top-2 left-2">
                    <CheckboxInput
                      color="gray"
                      label=""
                      :showLabel="false"
                      :value="item"
                      :checked="isSelected(item)"
                      @update:modelValue="toggleSelection(item)" />
                  </div>
                  <router-link v-if="full" :to="{ name: 'media-show', params: { id: item.id }}">
                    <img loading="lazy" class="aspect-[2/1] object-cover object-center rounded-lg" :src="item.url" :alt="item.alt">
                  </router-link>
                  <img v-else loading="lazy" class="aspect-[2/1] object-cover object-center border border-oakwood-gray-100" :src="item.url" :alt="item.alt">
                  <div class="absolute bottom-4 left-4 rounded p-1 bg-white max-w-[calc(100%-2rem)]">
                    <span class="text-sm font-normal text-bhav-blue-500 truncate block">{{ item.filename }}</span>
                  </div>
                </div>
                <div class="p-4 text-start">
                  <div><span class="text-bhav-blue-500 truncate block text-sm font-semibold">{{ item.alt }}</span></div>
                  <div><span class="text-bhav-blue-200 truncate block text-sm font-normal mb-4">{{ item.caption }}</span></div>
                  <div class="flex gap-1 flex-wrap">
                                    <span v-for="(tag, idx) in getTags(item)"
                                          :key="`tag-${idx}`"
                                          class="rounded p-1 items-center justify-center text-sm font-normal whitespace-nowrap"
                                          :class="[tag.bgColor, tag.textColor]">
                                        {{ tag.label }}
                                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Card>

        </template>
        <template #none>
          No matching media items found.
        </template>
      </PaginationGrid>

      <div v-if="view === 'list'" class="overflow-x-auto pr-5">
        <PaginationTable empty-message="There are currently no media." :has-top-nav="true" :legacy="false" :data="filtered" :columns="columns" view="media-list-view" :showColumns="showColumns" :server-side="!!pagination" :server-pagination="pagination" @page-change="handlePageChange" @limit-change="handleLimitChange" @sort-change="handleSortChange" @closeDrawer="showColumns = false">
          <template #col-selector-header="{ paginated }">
            <CheckboxInput
                :showLabel="false"
                label="Select All"
                color="white"
                :value="true"
                :modelValue="areAllSelected(paginated) ? true : false"
                @update:modelValue="toggleSelectAllOnPage(paginated)" />
          </template>
          <template #col-selector="{ row }">
            <CheckboxInput
                :showLabel="false"
                label="Select Row"
                :value="row"
                :checked="isSelected(row)"
                @update:modelValue="toggleSelection(row)" />
          </template>
          <template #col-thumbnail="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              <img loading="lazy" :src="row.url ?? null" :alt="row.alt" class="rounded-lg w-10 h-10 min-w-10 min-h-10 object-cover" />
            </router-link>
          </template>
          <template #col-public-title="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ row.alt }}
            </router-link>
          </template>
          <template #col-public-caption="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ row.caption }}
            </router-link>
          </template>
          <template #col-filesize="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ numberFromBytes(row.filesize) }}
            </router-link>
          </template>
          <template #col-filename="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ row.filename }}
            </router-link>
          </template>
          <template #col-upload-date="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ this.getDate(row.created_at) }}
            </router-link>
          </template>
          <template #col-creator="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              {{ row.creator?.name }}
            </router-link>
          </template>
          <template #col-communities="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              <div class="inline-flex items-center gap-2 flex-nowrap">
                        <span v-for="tag,i in getTags(row).filter(tag => tag.type === 'community')" :key="`tag-community-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                            {{ tag.label }}
                        </span>
              </div>
            </router-link>
          </template>
          <template #col-collections="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              <div class="inline-flex items-center gap-2 flex-nowrap">
                        <span v-for="tag,i in getTags(row).filter(tag => tag.type === 'collection')" :key="`tag-collection-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                            {{ tag.label }}
                        </span>
              </div>
            </router-link>
          </template>
          <template #col-floorplans="{ row }" class="w-auto">
            <router-link :to="{ name: 'media-show', params: { id: row.id }}">
              <div class="inline-flex items-center gap-2 flex-nowrap">
                        <span v-for="tag,i in getTags(row).filter(tag => tag.type === 'floorplan')" :key="`tag-floorplan-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                            {{ tag.label }}
                        </span>
              </div>
            </router-link>
          </template>
          <!-- <template #col-elevation="{ row }">
              <div class="p-1.5">
                  <span v-if="row.meta?.elevation" class="bg-bhav-bright-blue-100 text-bhav-bright-blue-500 rounded-lg p-1 whitespace-nowrap">{{ row.meta?.elevation }}</span>
              </div>
          </template>
          <template #col-color-package="{ row }">
              <div class="p-1.5">
                  <span v-if="row.meta?.color_package" class="bg-bhav-bright-blue-100 text-bhav-bright-blue-500 rounded-lg p-1 whitespace-nowrap">{{ row.meta?.color_package }}</span>
              </div>
          </template> -->
          <template #col-attached-communities="{ row }" class="w-auto">
            <div class="inline-flex items-center gap-2 flex-nowrap">
                      <span v-for="tag,i in getAttachments(row, 'division')" :key="`tag-attached-community-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                          {{ tag.label }}
                      </span>
            </div>
          </template>
          <template #col-attached-collections="{ row }" class="w-auto">
            <div class="inline-flex items-center gap-2 flex-nowrap">
                      <span v-for="tag,i in getAttachments(row, 'collection')" :key="`tag-attached-collection-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                          {{ tag.label }}
                      </span>
            </div>
          </template>
          <template #col-attached-floorplans="{ row }" class="w-auto">
            <div class="inline-flex items-center gap-2 flex-nowrap">
                      <span v-for="tag,i in getAttachments(row, 'floorplan')" :key="`tag-attached-floorplan-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                          {{ tag.label }}
                      </span>
            </div>
          </template>
          <template #col-attached-sales="{ row }" class="w-auto">
            <div class="inline-flex items-center gap-2 flex-nowrap">
                      <span v-for="tag,i in getAttachments(row, 'sales_order')" :key="`tag-attached-sales-order-${i}`" :class="[tag.bgColor,tag.textColor,'rounded-lg p-1 whitespace-nowrap']">
                          {{ tag.label }}
                      </span>
            </div>
          </template>
          <template #col-keywords="{ row }" class="w-auto">
            <div class="inline-flex items-center gap-2 flex-nowrap">
                      <span v-for="keyword,i in row.keywords" :key="`tag-keyword-${i}`" class="rounded-lg p-1 whitespace-nowrap text-bhav-orange-500 bg-bhav-orange-100">
                          {{ keyword.name }}
                      </span>
            </div>
          </template>
        </PaginationTable>
      </div>
    </div>


    <div v-if="!full" class="flex justify-end gap-4 bg-white p-3 rounded-b-md flex-shrink-0" :class="[{'pr-6': view === 'list'}]">
      <div>
        <FormButton @click="closeModal()" color="gray" class="mr-2">Cancel</FormButton>
        <FormButton @click="saveAttach()" :disabled="selected.length == 0" font-style="font-normal" color="blue">Attach Selected</FormButton>
      </div>
    </div>

    <ModalDialog v-if="confirmCsv" :b :hide-header="true" @close="() => { confirmCsv = false; }" :no-padding="true" :open="!!confirmCsv">
      <template #body>
        <div class="w-full h-32 rounded-lg bg-bhav-blue-50 flex items-center justify-center mb-3"><span class="text-bhav-blue-500 text-5xl fak fa-download"></span></div>
        <div class="text-lg flex w-full items-center justify-center font-medium text-bhav-blue-500 mb-1">Confirm Download</div>
        <div class="text-base flex w-full items-center text-center justify-center font-medium text-bhav-blue-400">Confirm you would like to export a CSV with the current applied filters</div>
      </template>
      <template #buttons>
        <div class="gap-2">
          <FormButton @click="() => { confirmCsv = false; }" color="gray" class="mr-2">Cancel</FormButton>
          <FormButton @click="download()" font-style="font-normal" color="blue">Download CSV</FormButton>
        </div>
      </template>
    </ModalDialog>

    <ModalDialog v-if="downloaded" :b :hide-header="true" @close="() => { downloaded = false; }" :no-padding="true" :open="!!downloaded">
      <template #body>
        <div class="w-full h-32 rounded-lg flex items-center justify-center mb-3" :class="downloadError ? 'bg-bhav-red-100 ' : 'bg-bhav-blue-100 '"><span class="text-5xl fak fa-download" :class="downloadError ? 'text-bhav-red-500 ' : 'text-bhav-blue-500 '"></span></div>
        <div class="text-lg flex w-full items-center justify-center font-medium text-bhav-blue-500 mb-1">{{ downloadError ? 'Report Download Failed' : 'Report Successfully Download' }}</div>
      </template>
      <template #buttons>
        <FormButton @click="() => { downloaded = false; downloadError = false }" color="gray" class="w-full items-center justify-center">Ok</FormButton>
      </template>
    </ModalDialog>

    <ModalDialog v-if="confirm" :hide-header="true" @close="() => { confirm = false; }" :no-padding="true" :open="!!confirm">
      <template #body>
        <div class="w-full h-32 rounded-lg bg-bhav-red-100 flex items-center justify-center mb-3"><span class="text-bhav-red-500 text-5xl fa fa-trash"></span></div>
        <div class="text-lg flex w-full items-center justify-center font-medium text-bhav-blue-500 mb-1">Delete selected images</div>
        <div class="text-base flex w-full items-center text-center justify-center font-medium text-bhav-blue-400">Are you sure you want to delete the selected images?</div>
      </template>
      <template #buttons>
        <div class="gap-2">
          <FormButton @click="() => { confirm = false; }" color="gray" class="mr-2">Cancel</FormButton>
          <FormButton @click="drop" font-style="font-normal" color="blue">Delete</FormButton>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { GlobalPolicy } from '@/policies/global';
import Card from './Card.vue';
import ModalDialog from './ModalDialog.vue';
import PaginationGrid from './PaginationGrid.vue';
import FormButton from "./form/FormButton.vue";
import axios from "axios";
import { CheckboxInput, TextInput } from './form';
import PaginationTable from './PaginationTable.vue';
import { numberFromBytes } from '@/helpers/numberHelpers';
import RightDrawer from './RightDrawer.vue';
import FileDownload from 'js-file-download';
import MultiselectField from './form/MultiselectField.vue';
import Media from '@/models/media';
import { mapState, mapWritableState, mapActions } from 'pinia';
import { userMediaStore } from '@/stores/media';
import ViewToggle from './ViewToggle.vue';
import SearchInput from './form/SearchInput.vue';

export const mediaBrowserColumns = [
  {
    name: 'selector',
    label: '',
    show: false,
    default: true,
    sort: false,
    class: 'w-auto'
  },
  {
    name: 'thumbnail',
    label: 'Image',
    default: true,
    sort: false,
    icon: 'fak fa-photo',
    class: 'w-auto'
  },
  {
    name: 'public-title',
    label: 'Public Title',
    sort: (row) => row.alt,
    default: true,
    icon: 'fas fa-feather-pointed',
    class: 'w-auto'
  },
  {
    name: 'public-caption',
    label: 'Public Caption',
    sort: (row) => row.caption,
    default: true,
    icon: 'fas fa-square-ellipsis',
    class: 'w-auto'
  },
  {
    name: 'filesize',
    label: 'File Size',
    sort: (row) => row.filesize,
    default: true,
    icon: 'fas fa-ruler',
    class: 'w-auto'
  },
  {
    name: 'filename',
    label: 'File Name',
    sort: (row) => row.filename,
    default: true,
    icon: 'fak fa-link',
    class: 'w-auto'
  },
  {
    name: 'upload-date',
    label: 'Upload Date',
    sort: (row) => new Date(row.created_at).getTime(),
    default: true,
    icon: 'fak fa-history',
    class: 'w-auto'
  },
  {
    name: 'creator',
    label: 'Creator',
    sort: (row) => row.creator?.name || '',
    default: true,
    icon: 'fak fa-user',
    class: 'w-auto'
  },
  {
    name: 'communities',
    label: 'Communities',
    sort: false,
    default: false,
    icon: 'fak fa-community',
    class: 'w-auto'
  },
  {
    name: 'collections',
    label: 'Collections',
    sort: false,
    default: false,
    icon: 'fak fa-collection',
    class: 'w-auto'
  },
  {
    name: 'floorplans',
    label: 'Floorplans',
    sort: false,
    default: false,
    icon: 'fak fa-floorplan',
    class: 'w-auto'
  },
  // {
  //   name: 'elevation',
  //   label: 'Elevation',
  //   sort: (row) => row.meta.elevation,
  //   default: false,
  //   icon: 'fak fa-garage'
  // },
  // {
  //   name: 'color-package',
  //   label: 'Color Package',
  //   sort: (row) => row.meta.color_package,
  //   default: false,
  //   icon: 'fak fa-color-package'
  // }
  {
    name: 'attached-communities',
    label: 'Attached Communities',
    sort: false,
    default: false,
    icon: 'fak fa-community',
    class: 'w-auto'
  },
  {
    name: 'attached-collections',
    label: 'Attached Collections',
    sort: false,
    default: false,
    icon: 'fak fa-collection',
    class: 'w-auto'
  },
  {
    name: 'attached-floorplans',
    label: 'Attached Floorplans',
    sort: false,
    default: false,
    icon: 'fak fa-floorplan',
    class: 'w-auto'
  },
  {
    name: 'attached-sales',
    label: 'Attached Available Homes',
    sort: false,
    default: false,
    icon: 'fak fa-home-available',
    class: 'w-auto'
  },
  {
    name: 'keywords',
    label: 'Keywords',
    sort: false,
    default: false,
    icon: 'fak fa-password',
    class: 'w-auto'
  },
];

export default {
  setup() {
    return {
      GlobalPolicy,
      Media,
      numberFromBytes,
      viewOptions: [
        { value: 'grid', icon: 'fak fa-grid-view', label: 'Switch to Grid View' },
        { value: 'list', icon: 'fak fa-list-view', label: 'Switch to List View' }
      ],
      columns: mediaBrowserColumns
    }
  },
  emits: ['close','attach','edit','page-change','limit-change','filter-change','sort-change'],
  data() {
    return {
      isOpen: false,
      filtering: null,
      confirm: false,
      confirmCsv: false,
      downloaded: false,
      downloadError: false,
      showColumns: false
    }
  },
  computed: {
    ...mapState(userMediaStore, ['hasFilters']),
    ...mapWritableState(userMediaStore, ['query', 'page', 'selected']),
    ...mapWritableState(userMediaStore, { view: 'view_type' }),
    activeFiltersCount() {
      let count = 0;
      if (this.query.category.length > 0) count++;
      if (this.query.position.length > 0) count++;
      if (this.query.keywords.length > 0) count++;
      if (this.query.communities.length > 0) count++;
      if (this.query.collections.length > 0) count++;
      if (this.query.floorplans.length > 0) count++;
      if (this.query.elevation.length > 0) count++;
      if (this.query.color_package.length > 0) count++;
      if (this.query.attached != null) count++;
      return count;
    },
    filtered() {
      let results = this.media;

      results = results.filter(item => this.mimeTypes.includes(item.type));

      return results;
    },
    collections() {
      let collections = this.communities.flatMap(community => community.collections || []).filter(c => c != null).sort((a, b) => (a.kova?.MarketingName) > (b.kova?.MarketingName) ? 1 : -1);

      const collectionNames = new Set(collections.map(collection => collection.kova?.MarketingName));

      return [...collectionNames].filter(name => name != null);
    },
    availableFloorplan() {
      let results = this.floorplans;

      const floorplanNames = new Set(results.map(floorplan => floorplan.meta?.info?.name));

      return [...floorplanNames].filter(name => name != null);
    },
    mimeTypes() {
      const types = {
        Images : ['image/png', 'image/jpg', 'image/jpeg'],
        PDFs : ['application/pdf'],
        Videos : ['video/mpeg-4']
      };
      return Object.entries(types).filter(([type]) => {
        return this.query.search.types.includes(type)
      }).map(([,mimes]) => mimes).flat();
    }
  },
  methods: {
    ...mapActions(userMediaStore, ['clear']),
    handlePageChange(page) {
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('page-change', page, filters);
      }
    },
    handleLimitChange(limit) {
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('limit-change', limit, filters);
      }
    },
    handleSortChange(column, direction) {
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('sort-change', column, direction, filters);
      }
    },
    handleSearch() {
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('filter-change', filters);
      }
    },
    handleSearchClear() {
      if (this.pagination) {
        // Clear search and reload
        this.query.search.string = '';
        const filters = this.getCurrentFilters();
        this.$emit('filter-change', filters);
      }
    },
    getCurrentFilters() {
      return {
        keywords: this.query.keywords,
        category: this.query.category.length > 0 ? this.query.category[0] : null,
        position: this.query.position.length > 0 ? this.query.position[0] : null,
        communities: this.query.communities,
        collections: this.query.collections,
        floorplans: this.query.floorplans,
        attached: this.query.attached,
        search: this.query.search.string,
      };
    },
    applyFilters() {
      // Copy filtering state to query
      if (this.filtering) {
        this.query.category = [...this.filtering.category];
        this.query.position = [...this.filtering.position];
        this.query.keywords = [...this.filtering.keywords];
        this.query.communities = [...this.filtering.communities];
        this.query.collections = [...this.filtering.collections];
        this.query.floorplans = [...this.filtering.floorplans];
        this.query.elevation = [...this.filtering.elevation];
        this.query.color_package = [...this.filtering.color_package];
        this.query.attached = this.filtering.attached;
      }
      this.isOpen = false;

      // Emit filter change event for server-side filtering
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('filter-change', filters);
      }
    },
    clearFilters() {
      this.clear();
      this.query.search.string = '';
      this.filtering = { ...this.query };

      // If server-side pagination is active, reload without filters
      if (this.pagination) {
        const filters = this.getCurrentFilters();
        this.$emit('filter-change', filters);
      }
    },
    resetFilters() {
      // Copy current query to filtering for editing
      if (!this.filtering) {
        this.filtering = { ...this.query };
      }
      this.isOpen = false;
    },
    getDate(date) {
        return new Intl.DateTimeFormat('en-US', {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
            timeZone: "America/Denver",
        }).format(new Date(date));
    },
    handleEdit() {
      this.$emit('edit', this.selected);
    },
    areAllSelected(items) {
      if (!items || items.length === 0) return false;
      if (this.selected.length === 0) return false;
      return items.every(item => this.isSelected(item));
    },
    toggleSelectAllOnPage(items) {
      if (!items || items.length === 0) return;

      const allSelected = this.areAllSelected(items);

      if (allSelected) {
        // Deselect all items on the page
        this.selected = this.selected.filter(selectedItem =>
            !items.some(item => item.id === selectedItem.id)
        );
      } else {
        // Select all items on the page (avoid duplicates)
        const newSelections = items.filter(item => !this.isSelected(item));
        this.selected = [...this.selected, ...newSelections];
      }
    },
    isSelected(item) {
      return this.selected.some(i => i.id === item.id);
    },
    toggleSelection(item) {
      const index = this.selected.findIndex(i => i.id === item.id);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
    },
    getTags(item) {
      const tags = [];

      // Communities tags (bright blue)
      if (item.meta?.communities && Array.isArray(item.meta.communities)) {
        item.meta.communities.forEach(community => {
          tags.push({
            label: this.getCommunityName(community),
            type: 'community',
            bgColor: 'bg-bhav-bright-blue-100',
            textColor: 'text-bhav-bright-blue-500'
          });
        });
      }

      // Collections tags (bright blue)
      if (item.meta?.collections && Array.isArray(item.meta.collections)) {
        item.meta.collections.forEach(collection => {
          tags.push({
            label: this.getCollectionName(collection),
            type: 'collection',
            bgColor: 'bg-bhav-bright-blue-100',
            textColor: 'text-bhav-bright-blue-500'
          });
        });
      }

      // Floorplan tag (bright blue)
      if (item.meta?.floorplan) {
        tags.push({
          label: this.getFloorplanName(item.meta.floorplan),
          type: 'floorplan',
          bgColor: 'bg-bhav-bright-blue-100',
          textColor: 'text-bhav-bright-blue-500'
        });
      }

      // Category tag (orange)
      if (item.meta?.category) {
        const categoryLabel = item.meta.category.charAt(0).toUpperCase() + item.meta.category.slice(1);
        tags.push({
          label: categoryLabel,
          type: 'category',
          bgColor: 'bg-bhav-orange-100',
          textColor: 'text-bhav-orange-500'
        });
      }

      // View tag if category is 'home' (orange)
      if (item.meta?.category === 'home' && item.meta?.position) {
        tags.push({
          label: item.meta.position,
          type: 'position',
          bgColor: 'bg-bhav-orange-100',
          textColor: 'text-bhav-orange-500'
        });
      }

      return tags;
    },
    getAttachments(item, type) {
      const attachments = [];

      if (item.attachments) {
        item.attachments.filter(attachment => attachment.item_type == type).forEach(attachment => {
          attachments.push({
            label: type == 'division' ? attachment.model?.meta?.info?.name ?? attachment.model?.kova?.WebGroupName : (type == 'collection' ? attachment.model?.kova?.MarketingName : (type == 'floorplan' ? attachment.model?.meta?.info?.name : (type == 'sales_order' ? attachment.model?.kova?.Name ?? '' : ''))),
            type: type,
            bgColor: 'bg-bhav-bright-blue-100',
            textColor: 'text-bhav-bright-blue-500'
          });
        });
      }

      return attachments;
    },
    saveAttach() {
      this.$emit('attach',this.selected);
      this.selected = [];
      this.$emit('close', false);
    },
    closeModal() {
      this.selected = [];
      this.$emit('close', false);
    },
    async drop() {

      const deletedIds = this.confirm.map(item => item.id);
      const deletePromises = deletedIds.map(itemToDelete =>
          axios.delete(`media/${itemToDelete}`)
              .catch(error => {
                console.error('Error deleting media:', error);
                return null;
              })
      );

      await Promise.all(deletePromises);
      const updatedMedia = this.media.filter(item => !deletedIds.includes(item.id));

      this.confirm = false;
      this.selected = [];
      this.$emit('close', updatedMedia);
    },
    getCommunityName(id) {
      const community = this.communities.find(c => c.id === id);
      return community ? (community.meta?.info?.name ?? community.kova?.WebGroupName) : null;
    },
    getCollectionName(id) {
      const collection = this.communities.flatMap(community => community.collections)?.find(c => c.community_rid === id);
      return collection?.kova?.MarketingName;
    },
    getFloorplanName(id) {
      const floorplan = this.floorplans.find(f => f.kova.ModelRID === id);
      return floorplan ? floorplan.meta?.info?.name : null;
    },
    download() {
      let params = "";
      for (var i = 0; i < this.filtered.length ?? 0; i++) {
        params += (i > 0 ? '&' : '?') + 'ids[]=' + this.filtered[i].id;
      }
      axios.get('/media/export' + params,  { responseType: 'blob' })
          .then(resp => {
            let date = new Date();
            FileDownload(resp.data, `media-${date.toLocaleDateString()}-${date.toLocaleTimeString().replace(' ', '_')}.csv`)
            this.downloaded = true;
            this.confirmCsv = false;
          })
          .catch(error => {
            this.downloadError = true;
            this.downloaded = true;
            this.confirmCsv = false;
            console.error(error);
          })
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        // Initialize filtering with current query state
        this.filtering = JSON.parse(JSON.stringify(this.query));
      }
    },
    query: {
      handler() { this.page = 1; },
      deep: true
    },
  },
  props: {
    full: {
      type: Boolean,
      default: true
    },
    media: {
      required: true,
      default: []
    },
    pagination: {
      type: Object,
      default: null
    },
    communities: {
      type: Array,
      default: () => []
    },
    floorplans: {
      type: Array,
      default: () => []
    },
    keywords: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ModalDialog,
    FormButton,
    TextInput,
    PaginationGrid,
    PaginationTable,
    Card,
    CheckboxInput,
    RightDrawer,
    MultiselectField,
    ViewToggle,
    SearchInput
  }
}
</script>

